import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import '../cssfiles/Contact.css'
import ContactImg from '../Images/Developer Logo(1)(1).png'

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      "service_d6ahrha",  // Replace with EmailJS Service ID
      "template_vvbyzpq", // Replace with EmailJS Template ID
      formData,
      "DX5FbNPwKPROCRUKU"   // Replace with EmailJS Public Key
    ).then(
      (response) => {
        alert("Message sent successfully! Thanks for your message . I will response you as soon as posible");
      },
      (error) => {
        alert("Failed to send message. Try again later.");
      }
    );
  };

  return ( 

    <>
     <p className="ContactMeTxt">Contact me</p>
    <p className="contactDesc" >Need a website or a game? I can help! I specialize in game development and web design. Feel free to contact me, and I'll respond as soon as possible. Or reach out for anything else!</p>
   
    <img className="ContactFrontImg" src={ContactImg}></img>
     <form onSubmit={handleSubmit}>
       
       <p className="Namelabel">Name*</p>
      <input id="Name" type="text" name="name" placeholder="Your Name" onChange={handleChange} required />
      <p className="YourEmaillabel">Your Email*</p>
      <input type="email" name="email" placeholder="Your Email" onChange={handleChange} required />
      <p className="Messagelabel">Your message*</p>
      <textarea name="message" placeholder="Your Message" onChange={handleChange} required />
      <button type="submit">Send Email</button>
      </form>
   <p className="SocialmediaTxt">Follow my journey on social media.</p>
   <div className="SocialMedias">
                <a className='instagram'  href='https://www.instagram.com/oxomgamedev?igsh=MWk2Y2R5b25qZmM1cg=='> <i class="fa-brands fa-instagram"></i></a>
                <a className='youtube'  href='https://youtube.com/@oxomgamedev?si=ELzs1hx4NHhblZ-E'><i class="fa-brands fa-youtube"></i></a>
                <a className='instagramtwo'  href='https://www.instagram.com/somim_ahm3d?igsh=MXZvcGt5cW8wY2dwZg=='> <i class="fa-brands fa-instagram"></i></a>
   </div>

    </>
   
  );
};

export default Contact;
